import { StreamActions } from "@hotwired/turbo"
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import GridNav from 'src/javascripts/components/surveys/GridNav';
import { closeFloatingTypeaheadsWithin } from 'src/javascripts/components/surveys/functions/SetManualTypeahead';

export default function() {

	StreamActions.reload_datatables = function() {
	  let tableId = this.getAttribute("table_id");
	  setTimeout(function() {
			$('#' + tableId).DataTable().ajax.reload();
		}, 500);
	}

	StreamActions.toast = function() {
	  let title = this.getAttribute("title");
	  let text = this.getAttribute("text");
	  let type = this.getAttribute("type");
	  let length = parseInt(this.getAttribute("length"));
	  ToastCustom({title: title, message: text, delay: length, type: type});
	}

	// Hide all tooltipls
	StreamActions.hide_tooltips = function() {
	  $('.tooltip').tooltip('hide');
	}

	// Show a modal
	StreamActions.show_modal = function() {
	  let modalId = this.getAttribute("modal_id");

	  // Remove existing modal
	  $('#' + modalId).remove();

		// Append content 
	  $('body').append(this.templateContent);

		// Enable client side validations in modal
		$('#' + modalId).on('shown.bs.modal', function() {
			$('#' + modalId).find('form').enableClientSideValidations();
		});

		// Re-init tooltips
		$('[data-toggle=tooltip]').tooltip();

		// Show the modal
	  $('#' + modalId).modal('show');
	}

	// Hide a modal
	StreamActions.hide_modal = function() {
	  let modalId = this.getAttribute("modal_id");

	  // Remove existing modal
	  $('#' + modalId).modal('hide');

	}

	// Show a Swal modal (used for confirmations)
	StreamActions.show_swal = function() {
		$('.swal2-container').remove();
		$('body').append(this.templateContent);
		$('.swal2-cancel').click(function() {
			$('.swal2-container').remove();
		})
	}

	StreamActions.load_survey_question_group = function() {

		// Append content
		let questionGroupId = this.getAttribute("question_group_id");
		let elTarget = $('.card[data-question-group-id=\'' + questionGroupId + '\']');

		// Capture the current badge HTML before replacing the DOM.
		// When the group is being COLLAPSED the server may render a stale badge
		// (e.g. "Incomplete" even though the client already marked it "Complete"
		// because the DB status field hasn't been updated by the poll yet).
		// We restore the pre-collapse badge so the user doesn't see a flicker.
		const prevStatusEl = elTarget.find('.question-group-status[data-question-group-id="' + questionGroupId + '"]');
		const prevBadgeHtml = prevStatusEl.length ? prevStatusEl.html() : null;

		// A floated menu (ET-3185) lives outside elTarget in document.body;
		// close it first so replaceWith() doesn't orphan it there.
		closeFloatingTypeaheadsWithin(elTarget[0]);

		// Replace DOM
	  elTarget.replaceWith(this.templateContent);

		// Navigating around the questionnaire grid layout
		GridNav('questionGroupList' + questionGroupId);

		// After replace, check whether the group is now collapsed (no question rows).
		// If so, the server badge may be stale – restore the badge that was showing
		// before the navigation so the UI stays consistent until the next poll
		// confirms the real status.
		const newCard = $('.card[data-question-group-id="' + questionGroupId + '"]');
		const isNowCollapsed = newCard.find('.question-row').length === 0;
		if (isNowCollapsed && prevBadgeHtml) {
			const newStatusEl = newCard.find('.question-group-status[data-question-group-id="' + questionGroupId + '"]');
			if (newStatusEl.length) {
				newStatusEl.html(prevBadgeHtml);
			}
		}

		// For groups that are now EXPANDED, re-evaluate all visible group badges
		// so the client-computed state is always applied after a turbo replace
		// (the server status field may lag behind the last save).

		const surveyStatusForBadge = $('.polling-indicator').attr('data-status');
		const isSurveyFinalizedForBadge = surveyStatusForBadge === 'submitted' || surveyStatusForBadge === 'approved';
		if (!isSurveyFinalizedForBadge && typeof window.refreshVisibleQuestionGroupStatuses === 'function') {
			window.refreshVisibleQuestionGroupStatuses();
		}

		// Re-init tooltips
		$('[data-toggle=tooltip]').tooltip();

	}


}



